<template>
    <div class="navbar-container fixed-top" :class="'nb-'+sitedata.settings[0].menucolortheme +' nb-'+sitedata.settings[0].menuwidth">
        <input type="checkbox" id="showmenu" class="d-none" name="showmenu" value="" v-model="menutoggler">
        <nav class="navbar navbar-expand-lg navbar-dark justify-content-between" id="mainnavselection">
            <!-- logo and menu icon -->
            <span :class="{'navbar-w-logo': sitedata.settings[0].logoimage}">
                <a class="navbar-brand" :href="urlprefix" v-if="readonly">
                    <span v-if="sitedata.settings[0].logoimage" class="logo-container">
                        <img :src="sitedata.settings[0].logoimage" alt="sitedata.name" class="logoimage"/>
                    </span>
                    <span v-else class="edited_content">
                        {{ sitedata.name }}
                    </span>
                </a>
                <span class="navbar-brand" v-if="!readonly">
                    <span v-if="sitedata.settings[0].logoimage" class="logo-container">
                        <img :src="sitedata.settings[0].logoimage" alt="sitedata.name" class="logoimage"/>
                    </span>
                    <inline-editor :editable="sitedata.name" dbentry="name" element="normal"/>
                </span>
            </span>
            <label class="navbar-toggler ml-auto" for="showmenu">
                <span class="sr-only">Menu</span> <span class="material-icons ico">menu</span>
            </label>

            <div class="collapse navbar-collapse" id="navigasean">
                <div class="navbar-nav ml-auto">

                    <!--- menu items -->
                    <span v-if="onepager" class='mainnavitem nav-item-home'>
                        <a v-if="mainpageid == 'home'" class="nav-item nav-link active scroll" :href="urlprefix" v-scroll-to="'#top'" @click.prevent="menutoggler = false">Home</a>
                        <a v-else class="nav-item nav-link active " :href="urlprefix">Home</a>
                    </span>
                    <span v-else class='mainnavitem nav-item-home'>
                        <a class="nav-item nav-link" :href="urlprefix" :class="{'active': $route.params.pageslug == null}">Home</a>
                    </span>
                    <span v-if="onepager" class='mainnavitem' v-for="menuitem in menupages" :class="'nav-item-'+menuitem.pageslug">
                        <a v-if="mainpageid == 'home'" class="nav-item nav-link scroll" :href="urlprefix+menuitem.pageslug" v-scroll-to="'#'+menuitem.pageslug" @click.prevent="menutoggler = false">{{ menuitem.pagetitle }}</a>
                        <a v-else class="nav-item nav-link " :href="urlprefix+menuitem.pageslug">{{ menuitem.pagetitle }}</a>
                    </span>
                    <span v-if="!onepager" class='mainnavitem' v-for="menuitem in menupages" :class="'nav-item-'+menuitem.pageslug">
                        <a class="nav-item nav-link" :class="{'active': $route.params.pageslug == menuitem.pageslug}" :href="urlprefix+menuitem.pageslug" >{{ menuitem.pagetitle }}</a>
                        <a  v-if="!readonly && !sitedata.settings[0].use_one_pager" href="#" class="remove_menu_item" @click.prevent="showModal = true, removepage = menuitem._id" ><span class="ico material-icons">cancel</span></a>
                    </span>
                    
                    <span class='mainnavitem' v-if="!readonly && !sitedata.settings[0].use_one_pager"><!-- adding new page -->
                        <span class="edited_content" v-if="!editmode">
                            <a class="edit_icon edit_icon_menu" @click.prevent="editmode = true" href="#"><span class="ico material-icons">add_circle</span></a>
                        </span>
                        <span class="edit_field" v-if="editmode">
                            <form id="edit_pagetext" method="post" @submit.prevent="createPage()">
                                <input class="textinput" type="text" v-model="pagetitle" autofocus placeholder="Naam van menu-item"/>
                                <button class="btn btn-primary">Opslaan</button>
                            </form>
                        </span>
                    </span>
                    <!-- end menu items -->

                    <social-icons v-if="sitedata.settings[0].sociallocation != 'onhome'"  :sitesettings="sitedata.settings[0]" class="mb-0 nav-social"/>
                </div>
            </div>

            <a v-if="sitedata.settings[0].ctamenulink || sitedata.settings[0].ctamenutext" :href="sitedata.settings[0].ctamenulink" class="btn ml-3 btn-primary">{{sitedata.settings[0].ctamenutext}}</a>

            <modal v-if="showModal" @close="showModal = false" title="Delete page">
                <form @submit.prevent="removePage(removepage)">
                    <p>Weet je zeker dat je de pagina en subpagina's wil verwijderen?</p>
                    <button class="button" type="submit">Ja, ik weet het zeker</button>
                </form>
            </modal>
        </nav>
    </div>
</template>

<script>
    import Modal from '../modal/Modal.vue';
    import SocialIcons from './SocialIcons.vue';
    import InlineEditor from '../app/InlineEditor.vue';

    import { userService } from '../../services/user.service.js';
    import { authHeader } from '../../services/auth-header.js';

    import axios from 'axios';

    export default {
        components:{
            Modal,
            InlineEditor,
            SocialIcons
        },
        props:{
            websiteid: String,
            mainpageid: String,
            readonly: Boolean,
            creatoreditor: Boolean,
            creatorhome: Boolean,
            sitedata: Object
        },
        data: function(){
            return{
                onepager: false,
                editmode: false,
                menupages: '',
                pagetitle: '',
                showModal: false,
                removepage: '',
                urlprefix: '',
                menutoggler: false
            }
        },
        methods: {
            getPages(belongsto){
                axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+belongsto)
                .then(response => {
                    this.menupages = response.data.response
                })
            },
            createPage(){
                const requestOptions = {
                headers: authHeader()
                }

                const data = {
                    websiteid: this.websiteid,
                    belongsto: 'nav',
                    pagetitle: this.pagetitle
                }

                axios.post(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
                .then(response => {
                    this.editmode = false,
                    this.pagetitle = ''
                    this.getPages('nav')
                })
            },
            removePage(id){
                const requestOptions = {
                    headers: authHeader()
                }

                axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/pageid/'+id, requestOptions)
                .then(response => {
                    this.showModal = false
                    this.getPages('nav')
                })
            }
        },
        mounted(){
            window.onscroll = function() {
                var toggler = document.getElementById('showmenu');
                toggler.checked = false;
                var windowpos = window.pageYOffset
                var navbar = document.getElementById('mainnavselection');
                if (windowpos > 10) {
                    navbar.className += " " + 'moving-nav';
                } else {
                    navbar.classList.remove("moving-nav");
                }
            };
            if(this.sitedata.settings[0].use_one_pager){
                this.getPages('home')
                this.urlprefix = '/#'
                this.onepager = true
            } else {
                console.log('testnav')
                this.getPages('nav')
                if(!this.creatoreditor){
                    this.urlprefix = '/'
                } else {
                    console.log('testnav2')
                    this.urlprefix = '/creator/'+this.websiteid+'/'
                }
            }
        },
        watch: {
            sitedata: {
                handler(sitedata) {
                    if(this.sitedata.settings[0].use_one_pager){
                        this.getPages('home')
                        this.urlprefix = '/#'
                        this.onepager = true
                    } else {
                        console.log('testnav')
                        this.getPages('nav')
                        if(!this.creatoreditor){
                            this.urlprefix = '/'
                        } else {
                            console.log('testnav2')
                            this.urlprefix = '/creator/'+this.websiteid+'/'
                        }
                    }
                }
            }
        }

    }
</script>
